<template>
  <overlay-panel
    ref="op"
    append-to="body"
    :show-close-icon="false"
    style="width: 365px"
    :breakpoints="{ '520px': '100vw' }"
  >
    <div class="settings-overlay">
      <div class="settings-overlay__title">{{ $t('common.security') }}</div>
      <div class="settings-overlay__divider" />
      <div class="settings-overlay__content">
        <PInputSwitch
          v-model="enableFrontrun"
          input-id="switch"
          class="settings-overlay__switch"
          :disabled="!canEnable"
        />
        <label class="settings-overlay__label" for="switch"
          ><h1 class="settings-overlay__label-title">
            {{ $t('swap.enableFrontrunningProtection') }}
          </h1>
          <h2 class="settings-overlay__label-subtitle">
            {{ $t('swap.availableOnlyForPontemWallet') }}
          </h2></label
        >
      </div>
      <div class="settings-overlay__divider" />
      <div class="links-wrapper">
        <a
          href="https://pontem.network/posts/liquidswap-adds-frontrunning-protection-dont-let-bots-get-your-money"
          rel="noreferrer noopener"
          target="_blank"
          class="links-wrapper__link links-wrapper__link_gray"
          >{{ $t('dialogs.howItWorks') }}
          <img
            class="ml-1 svg-gray-filter"
            width="12"
            src="@/assets/external-link.svg"
        /></a>
        <a
          :href="WALLET_CHROME_STORE_URL"
          rel="noreferrer noopener"
          target="_blank"
          class="links-wrapper__link"
          >{{ $t('common.downloadPontemWallet') }}</a
        >
      </div>
    </div>
  </overlay-panel>
</template>

<script lang="ts" setup>
import { WALLET_CHROME_STORE_URL } from '@/constants';
import { useStore, useSwapStore } from '@/store';
import { PontemWalletName } from '@pontem/aptos-wallet-adapter';
import { computed, ref } from 'vue';

const store = useStore();
const swapStore = useSwapStore();
const op = ref();

const canEnable = computed(() => store.walletName.value === PontemWalletName);

const enableFrontrun = computed({
  get() {
    return canEnable.value && swapStore.isFrontrunEnable;
  },
  set(v?: boolean) {
    if (v === undefined) return;
    swapStore.isFrontrunEnable = v;
  },
});

function show(e: Event, target?: any) {
  op?.value.show(e, target);
}

function hide() {
  op?.value.hide();
}

function toggle(e: Event, target?: any) {
  op?.value.toggle(e, target);
}

defineExpose({ show, hide, toggle });
</script>

<style scoped lang="scss">
.settings-overlay {
  &__title {
    display: flex;
    flex-direction: row;
    grid-gap: 12px;
    font-size: 1rem;
    color: var(--surface-200);
    margin-bottom: 8px;
    font-weight: 500;
  }

  &__divider {
    border-bottom: 1px solid #303035;
    margin: 0 -20px;
  }

  &__content {
    display: flex;
    padding-top: 12px;
  }

  &__label {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin-left: 8px;
  }

  &__label-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }

  &__label-subtitle {
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
    margin-top: 0;
    color: var(--text-color-secondary);
  }

  &__footer-label {
    display: block;
    width: fit-content;
    margin-left: auto;
    margin-top: 1rem;
    text-align: right;
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
    color: #946bec;
    cursor: pointer;
  }
}

:deep(.p-inputswitch.p-inputswitch-checked) {
  &.p-inputswitch-checked {
    .p-inputswitch-slider {
      background-color: var(--primary-color);
    }

    &:not(.p-disabled) {
      &:hover {
        .p-inputswitch-slider {
          background-color: var(--primary-color);
        }
      }
    }
  }
}

.links-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;

  &__link {
    display: block;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #946bec;
    cursor: pointer;

    &_gray {
      color: var(--text-color-secondary);
    }
  }
}

.svg-gray-filter {
  filter: invert(61%) sepia(16%) saturate(320%) hue-rotate(204deg)
    brightness(96%) contrast(87%);
}
</style>
